/* ── 1. COUNTDOWN TIMER ── */
(function(){
  var end = new Date();
  end.setHours(end.getHours()+5, end.getMinutes()+47, end.getSeconds()+33);
  function tick(){
    var diff = end - new Date();
    if (diff < 0){ end = new Date(new Date().getTime()+6*3600000); diff = end - new Date(); }
    var h = Math.floor(diff/3600000);
    var m = Math.floor((diff%3600000)/60000);
    var s = Math.floor((diff%60000)/1000);
    var elH=document.getElementById('cdHours'), elM=document.getElementById('cdMins'), elS=document.getElementById('cdSecs');
    if(elH) elH.textContent=String(h).padStart(2,'0');
    if(elM) elM.textContent=String(m).padStart(2,'0');
    if(elS) elS.textContent=String(s).padStart(2,'0');
  }
  tick(); setInterval(tick,1000);
})();

/* ── 2. BUNDLE SELECTOR ── */
function selectBundle(card){
  document.querySelectorAll('.op-bnd__card').forEach(function(c){c.classList.remove('op-sel');});
  card.classList.add('op-sel');
  var sale=card.dataset.sale, orig=card.dataset.orig, pct=card.dataset.pct, lbl=card.dataset.lbl;
  var qty=card.dataset.qty || '1', vid=card.dataset.variantId || '';
  // Update display values
  var elSale=document.getElementById('opSalePrice'),
      elOrig=document.getElementById('opOrigPrice'),
      elPill=document.getElementById('opSavePill'),
      elLbl =document.getElementById('opBundleLbl'),
      elSATC=document.getElementById('opSatcPrice');
  if(elSale) elSale.textContent=sale;
  if(elOrig) elOrig.textContent=orig;
  if(elPill) elPill.textContent=pct;
  if(elLbl)  elLbl.textContent =lbl;
  if(elSATC) elSATC.textContent=sale;
  // Update real cart-form values so the ATC button posts the right product
  var elQty = document.getElementById('opCartQty');
  var elVid = document.getElementById('opVariantId');
  if(elQty) elQty.value = qty;
  if(elVid && vid) elVid.value = vid;
}

/* ── 2b. STICKY ATC TRIGGER ── Submits the main hero ATC form ── */
function submitOpCart(){
  var f = document.getElementById('opAtcForm');
  if(f){ f.submit(); }
}

/* ── 3. GALLERY CAROUSEL — native scroll-snap, thumb sync ── */
function opGalGoTo(sectionId, idx, thumbEl){
  var main = document.getElementById('opGalMain-' + sectionId);
  if(!main) return;
  var slides = main.querySelectorAll('.op-gal__slide');
  if(!slides[idx]) return;
  main.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
  var thumbs = document.querySelectorAll('#opGalThumbs-' + sectionId + ' .op-gal__thumb');
  thumbs.forEach(function(t){ t.classList.remove('op-act'); });
  if(thumbEl){ thumbEl.classList.add('op-act'); }
  else if(thumbs[idx]){ thumbs[idx].classList.add('op-act'); }
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[id^="opGalMain-"]').forEach(function(main){
    var sectionId = main.id.replace('opGalMain-', '');
    var thumbs = document.querySelectorAll('#opGalThumbs-' + sectionId + ' .op-gal__thumb');
    if(!thumbs.length) return;
    var st = null;
    main.addEventListener('scroll', function(){
      if(st) clearTimeout(st);
      st = setTimeout(function(){
        var w = main.clientWidth;
        if(!w) return;
        var idx = Math.round(main.scrollLeft / w);
        thumbs.forEach(function(t, i){ if(i === idx) t.classList.add('op-act'); else t.classList.remove('op-act'); });
      }, 80);
    }, { passive: true });
  });
});

/* ── 4. BUYBOX ACCORDION ── */
function toggleBuyboxAccordion(btn){
  var item = btn.closest('.op-acc__item');
  var body = item.querySelector('.op-acc__body');
  var isOpen = item.classList.contains('op-open');
  document.querySelectorAll('.op-acc__item').forEach(function(i){
    i.classList.remove('op-open');
    var b = i.querySelector('.op-acc__body'); if(b) b.style.maxHeight='0';
  });
  if(!isOpen){ item.classList.add('op-open'); body.style.maxHeight = body.scrollHeight+'px'; }
}

/* ── 5. FAQ ACCORDION ── */
function toggleFaqAccordion(btn){
  var item = btn.closest('.op-faq__item');
  var body = item.querySelector('.op-faq__body');
  var isOpen = item.classList.contains('op-open');
  document.querySelectorAll('.op-faq__item').forEach(function(i){
    i.classList.remove('op-open');
    var b = i.querySelector('.op-faq__body'); if(b) b.style.maxHeight='0';
  });
  if(!isOpen){ item.classList.add('op-open'); body.style.maxHeight = body.scrollHeight+'px'; }
}

/* ── 6. STATS COUNT-UP ── */
(function(){
  var hasRun = false;
  function animateStats(){
    if(hasRun) return; hasRun = true;
    document.querySelectorAll('.op-cu').forEach(function(el){
      var target = parseInt(el.dataset.t,10);
      var current = 0;
      var stepTime = Math.max(10, Math.round(1600/target));
      var timer = setInterval(function(){
        current++;
        el.textContent = current+'%';
        if(current >= target) clearInterval(timer);
      }, stepTime);
    });
  }
  if('IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting) animateStats();
    }, { threshold: 0.3 });
    var statsSection = document.querySelector('.op-stats-section');
    if(statsSection) observer.observe(statsSection);
  } else { animateStats(); }
})();

/* ── 7. GIFT COUNT DECREMENT ── */
(function(){
  var count = 47;
  var el = document.getElementById('opGiftCount');
  if(!el) return;
  setInterval(function(){
    if(Math.random() < 0.12 && count > 5){ count--; el.textContent = count; }
  }, 14000);
})();

/* ── 8. STICKY MOBILE ATC + DELIVERY BANNER ── */
(function(){
  var heroSection = document.getElementById('opHeroSection');
  var stickyBar   = document.getElementById('opStickyAtc');
  var delivBar    = document.getElementById('opDelivBar');
  if(!heroSection || !stickyBar) return;
  window.addEventListener('scroll', function(){
    var heroBottom = heroSection.getBoundingClientRect().bottom;
    if(heroBottom < 0){
      stickyBar.classList.add('op-show');
      if(delivBar) delivBar.classList.add('op-show');
    } else {
      stickyBar.classList.remove('op-show');
      if(delivBar) delivBar.classList.remove('op-show');
    }
  }, { passive: true });
})();

/* ── 9. DELIVERY DATE + COUNTDOWN TO MIDNIGHT ── */
(function(){
  var dateEl    = document.getElementById('opDeliveryDate');
  var cdEl      = document.getElementById('opDeliveryCountdown');
  var bannerEl  = document.getElementById('opDelivBarDate');
  if(!dateEl && !cdEl && !bannerEl) return;
  // Delivery date = today + 4 calendar days (skipping Sun)
  function getDeliveryDate(longForm){
    var d = new Date(); d.setDate(d.getDate()+4);
    if(d.getDay()===0) d.setDate(d.getDate()+1); // skip Sunday
    var days=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return longForm ? days[d.getDay()]+', '+d.getDate()+' '+months[d.getMonth()] : days[d.getDay()];
  }
  if(dateEl)   dateEl.textContent   = getDeliveryDate(true);
  if(bannerEl) bannerEl.textContent = getDeliveryDate(true);
  function tickDelivery(){
    var end = new Date(); end.setHours(23,59,59,0);
    var diff = end - new Date();
    if(diff < 0){
      if(dateEl)   dateEl.textContent   = getDeliveryDate(true);
      if(bannerEl) bannerEl.textContent = getDeliveryDate(true);
      diff += 86400000;
    }
    var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
    if(cdEl) cdEl.textContent = String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
  }
  tickDelivery(); setInterval(tickDelivery, 1000);
})();
